import React from "react";

const SectionDivider = ({ margin }) => {
  return (
    <div
      className={`w-full max-w-7xl mx-auto bg-black h-[1px] ${margin} mb-20`}
    ></div>
  );
};

export default SectionDivider;
